// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1F5w3","actionsCol":"EnrolledClinics_actionsCol__2B9vh"};